import React, { useState } from 'react';
import { Button, Row, Col, InputGroup } from 'react-bootstrap';
import { FormNumberInput, FormSelect } from '@awp/components/Common/AwpFormInputs';

export const ObservationDataPrecedence = React.forwardRef((props) => {
  const displayErrorMessage = (message) => {
    props.setErrorMessage(message);
  };

  const handlePrecedenceChange = (index, value) => {
    if (!isNaN(value) && value >= 0 && value <= 1 && (value.match(/^\d*(\.\d{0,2})?$/) || []).length > 0) {
      props.onPrecedenceChange(index, value);
    }
  };

  const getAvailableOptions = () => {
    if (props.persistentPrecedentFilters == null) {
      return [];
    }
    const selectedTypeIds = props.persistentPrecedentFilters
      .map((obs) => obs.ObservationTypeId)
      .filter((id) => id !== null);

    return props.observationData.filter((option) => !selectedTypeIds.includes(option.id));
  };

  const handleAddObservation = () => {
    const hasUnselectedObservation = props.persistentPrecedentFilters.some((filter) => !filter.ObservationTypeId);

    if (hasUnselectedObservation) {
      displayErrorMessage('Please select an observation type before adding a new one.');
      return;
    }
    props.onAdd();
  };

  if (!props.persistentPrecedentFilters) {
    return <></>;
  }
  return (
    <>
      {props.persistentPrecedentFilters.map((precedentFilters, idx) => {
        const selectedOption =
          props.observationData.find((option) => option.id === precedentFilters?.ObservationTypeId) || null;
        return (
          ((!props.readOnly && selectedOption != null) || props.readOnly) && (
            <div key={`${idx}`}>
              <Row>
                <Col sm={5}>
                  <FormSelect
                    readOnly={!props.readOnly}
                    label={'Observation Type'}
                    id={`PersistentPrecedentFilters[${idx}].ObservationTypeId`}
                    name={`PersistentPrecedentFilters[${idx}].ObservationTypeId`}
                    postChange={(e) => {
                      props.setErrorMessage('');
                      props.onObservationTypeChange(idx, e.id);
                    }}
                    textValue={selectedOption}
                    options={getAvailableOptions()}
                    placeholder={'Select ...'}
                    isMulti={false}
                  />
                </Col>
                <Col sm={3}>
                  <FormNumberInput
                    readOnly={!props.readOnly}
                    label="Precedence"
                    name={`PersistentPrecedentFilters[${idx}].Relative_Precedence_Number`}
                    postChange={(value) => {
                      if (value == '') {
                        value = 0.5;
                        return true;
                      }
                      handlePrecedenceChange(idx, value);
                    }}
                    defaultValue={
                      typeof Number(precedentFilters.Relative_Precedence_Number) === 'number' &&
                      !isNaN(Number(precedentFilters.Relative_Precedence_Number))
                        ? precedentFilters.Relative_Precedence_Number
                        : 0.5
                    }
                    disabled={!precedentFilters.ObservationTypeId}
                    isAllowed={(values) => {
                      props.setErrorMessage('');
                      const { value } = values;
                      if (!precedentFilters.ObservationTypeId) {
                        displayErrorMessage('Please select an Observation Type before setting Precedence.');
                        return false;
                      }
                      if (value == '') {
                        values.value = 0.5;
                        return true;
                      }
                      const num = parseFloat(value);
                      const isValid =
                        !isNaN(num) && num >= 0 && num <= 1 && (value.match(/^\d*(\.\d{0,2})?$/) || []).length > 0;
                      if (!isValid) {
                        displayErrorMessage('Please enter a number (up to 2 decimal places) between 0 and 1.');
                      }
                      return isValid;
                    }}
                  />
                </Col>
                {props.readOnly && (
                  <Col sm={1}>
                    <InputGroup className="mb-3 mt-2 preset-obs-button-grp">
                      <Button
                        className="fas fa-plus awp-img-btn"
                        title="Add Precedence"
                        variant="outline-light"
                        onClick={(e) => {
                          props.setErrorMessage('');
                          e.stopPropagation();
                          handleAddObservation();
                        }}
                        style={{
                          color: '#000',
                          borderColor: 'transparent',
                          backgroundColor: 'transparent',
                        }}
                      />
                      {(precedentFilters?.ObservationTypeId != null || props.persistentPrecedentFilters.length > 1) && (
                        <Button
                          className="fas fa-trash awp-img-btn"
                          title="Delete Precedence"
                          variant="outline-light"
                          style={{
                            color: '#000',
                            borderColor: 'transparent',
                            backgroundColor: 'transparent',
                          }}
                          disabled={false}
                          onClick={(e) => {
                            props.setErrorMessage('');
                            e.stopPropagation();
                            props.onDelete(idx);
                          }}
                        />
                      )}
                    </InputGroup>
                  </Col>
                )}
              </Row>
            </div>
          )
        );
      })}
      <Row>
        <Col sm={8}>{props.errorMessage && <div className="text-danger mb-2">{props.errorMessage}</div>}</Col>
      </Row>
    </>
  );
});

ObservationDataPrecedence.displayName = 'ObservationDataPrecedence';
